import { reactive, toRefs, nextTick, onActivated, watch } from 'vue'
import { trim } from '@/common/js/utils'
import { transferTaskQueryConditions } from '@/views/download-center/data/utils.js'
import dimension_data from '@/views/material/data/dimension_data'
const getQueryForm = () => {
  return {
    keyword: '',
    imgTypes: [],
    searchType: 1, // 搜索类型
    imageStyles: [],
    imageOrientations: [],
    imageSizeConditions: [],
    adAccountIdList: [],
    labelId: [], // 标签ID
    designerIds: [],
    plannerIds: [],
    gameGroupIds: [],
    dataGroupIds: [],
    gameIds: [],
    dataGameIds: [],
    mediaIds: [],
    launchOpIdList: [],
    platforms: [],
    aiLabelIds: [],
    uploadtime: [], // 初始上传时间
    lauchTime: [], // 消耗起始时间
    videoLabelId: [],
    amountOperatorType: 5,
    amountValue: undefined,
    newRoleRateOperatorType: 5,
    newRoleRateValue: undefined
  }
}

export const COMPARE_OPERATOR_OPTIONS = [
  { label: '大于', value: 5 },
  { label: '小于', value: 6 },
  { label: '等于', value: 4 },
  { label: '大于等于', value: 1 },
  { label: '小于等于', value: 2 }
]

export const imageTypes = [
  { id: 1, name: '图片' },
  { id: 2, name: '视频' },
  { id: 8, name: '组图' },
  { id: 14, name: '试玩素材' }
]

export const imageTypesWithGroup = [
  { id: 1, name: '图片' },
  { id: -18, name: '图片&组图' },
  { id: 2, name: '视频' },
  { id: 8, name: '组图' },
  { id: 14, name: '试玩素材' }
]

export const useFilter = (route, emit, imageStyleTagTree) => {
  const state = reactive({
    queryForm: getQueryForm(),
    imageStyleHandleFlag: false
  })

  const disabledDate = (date) => {
    return date && date.valueOf() > Date.now() - 1000 * 60 * 60 * 24
  }

  const isValidAmount = (value) => value === undefined || value === null || value === '' || (Number.isInteger(value) && value >= 0)
  const isValidNewRoleRate = (value) =>
    value === undefined || value === null || value === '' || (typeof value === 'number' && value >= 0 && value <= 100)

  const buildParams = () => {
    const {
      keyword,
      platforms,
      imageStyles,
      labelId,
      videoLabelId,
      designerIds,
      plannerIds,
      gameIds,
      dataGameIds,
      mediaIds,
      imgTypes,
      imageOrientations,
      imageSizeConditions,
      adAccountIdList,
      dataGroupIds,
      gameGroupIds,
      launchOpIdList,
      aiLabelIds,
      amountOperatorType,
      amountValue,
      newRoleRateOperatorType,
      newRoleRateValue
    } = state.queryForm

    const imageStyleIds = imageStyles.length ? imageStyles.map((i) => i.slice(-1)).flat() : []
    const processedAiLabelIds = aiLabelIds.map((i) => i.slice(-1)).flat()
    const labelIds = [labelId, videoLabelId, imageStyleIds, processedAiLabelIds].filter((i) => Array.isArray(i)).flat()
    const imgSizes = imageSizeConditions.map((sizeValue) => {
      const item = dimension_data.find((d) => d.key === sizeValue)
      return item.value
    })
    const params = {
      platforms,
      designerIds,
      plannerIds,
      gameIds,
      dataGameIds,
      mediaIds,
      imgTypes,
      imageOrientations,
      adAccountIdList,
      imageSizeConditions: imgSizes,
      dataGroupIds,
      gameGroupIds,
      labelIdsStr: labelIds.join(','),
      launchOpIdsStr: launchOpIdList?.length ? launchOpIdList.join(',') : ''
    }

    if (amountValue !== undefined && amountValue !== null && amountValue !== '' && isValidAmount(amountValue)) {
      params.amountCompare = { operatorType: amountOperatorType, value1: amountValue }
    }
    if (newRoleRateValue !== undefined && newRoleRateValue !== null && newRoleRateValue !== '' && isValidNewRoleRate(newRoleRateValue)) {
      params.newRoleRateCompare = { operatorType: newRoleRateOperatorType, value1: newRoleRateValue }
    }
    const { uploadtime, lauchTime, searchType } = state.queryForm

    const [uploadBeginTime, uploadEndTime] = uploadtime || []
    if (uploadBeginTime && uploadEndTime) {
      params.uploadBeginTime = uploadBeginTime
      params.uploadEndTime = uploadEndTime
    }

    const [lauchTimeBegin, lauchTimeEnd] = lauchTime || []
    if (lauchTimeBegin && lauchTimeEnd) {
      params.lauchTimeBegin = lauchTimeBegin
      params.lauchTimeEnd = lauchTimeEnd
    }

    const key = [undefined, 'imageName', 'planName'][searchType]
    if (key) params[key] = trim(keyword)

    return params
  }

  const getTransferedTaskQueryConditions = (extraParams, pageType) => {
    return transferTaskQueryConditions.call({ buildParams }, { ...buildParams(), ...extraParams }, pageType)
  }

  const setQueryParams = (conditionInfo) => {
    state.queryForm = {
      ...getQueryForm(),
      ...conditionInfo
    }
  }

  const sendEvent = () => {
    emit('change')
  }

  // 处理当选择的素材标签是第一级时，需要把当前的二级也全部选中
  // 等待素材样式树形数据后，遍历其children构造级联全选需要的数据结构
  const handleParentImageStyleCheckAll = (treeList) => {
    const { imageStyles } = state.queryForm
    if (imageStyles.length) {
      const [labelId] = imageStyles[0]
      if (state.imageStyleHandleFlag) {
        const needle = treeList.find((i) => i.labelId === labelId)
        if (needle && needle.children?.length) {
          const imageStyles = needle.children.map((c) => [c.parentId, c.labelId])

          nextTick(() => {
            state.queryForm.imageStyles = [...imageStyles]
          })
        }
        state.imageStyleHandleFlag = false
      }
    }
  }

  const handleUrlQueryParams = () => {
    // labelId, videoLabelId, styleId 从src/views/material/tags/Tags.vue  [toMaterialPageList] 传递过来的
    // styleId 和其他参数 还可以从src/views/report/materials/AnalysisLabel.vue [toMaterialReportPage] 传递过来的

    const { labelId, videoLabelId, styleId, imageStyles, mediaId, imgTypes, dataGroupIds, gameGroups } = route.query
    const styleIdList = styleId && styleId.startsWith('[') ? JSON.parse(styleId) : []
    const imageStylesList = imageStyles && imageStyles.startsWith('[') ? JSON.parse(imageStyles) : []
    const labelIdList = labelId && labelId.startsWith('[') ? JSON.parse(labelId) : []
    const videoLabelIdList = videoLabelId && videoLabelId.startsWith('[') ? JSON.parse(videoLabelId) : []
    const gameGroupIdsList = gameGroups && gameGroups.startsWith('[') ? JSON.parse(gameGroups) : []
    const dataGroupIdsList = dataGroupIds && dataGroupIds.startsWith('[') ? JSON.parse(dataGroupIds) : []
    const imgTypesList = imgTypes && imgTypes.startsWith('[') ? JSON.parse(imgTypes) : []

    const queryForm = {
      ...getQueryForm(),
      labelId: labelIdList,
      videoLabelId: videoLabelIdList,
      mediaIds: mediaId ? [parseInt(mediaId)] : [],
      imgTypes: imgTypesList?.length ? imgTypesList : [],
      gameGroupIds: gameGroupIdsList?.length ? gameGroupIdsList : [],
      dataGroupIds: dataGroupIdsList?.length ? dataGroupIdsList : []
    }

    if (styleIdList?.length) {
      // imageStyles级联为多个二维数组的结构[[],[]]
      // 优先使用styleId来回显素材样式
      queryForm.imageStyles = [styleIdList]
    } else if (imageStylesList?.length) {
      // 只有src/views/report/materials/AnalysisLabel.vue [toMaterialReportPage] 会传递imageStyles参数
      // 没有styleId时，使用imageStyles回显素材样式
      queryForm.imageStyles = imageStylesList
    }

    state.queryForm = queryForm

    // handleParentImageStyleCheckAll
    if (styleIdList.length === 1) {
      state.imageStyleHandleFlag = true
      // 如果已经缓存了imageStyleTagTree，那么不会再触发watch
      if (imageStyleTagTree.value?.length) {
        handleParentImageStyleCheckAll(imageStyleTagTree.value)
      }
    }
  }

  watch(
    () => imageStyleTagTree.value,
    (v) => {
      handleParentImageStyleCheckAll(v)
    }
  )

  onActivated(() => {
    if (!Object.keys(route.query).length) return
    handleUrlQueryParams()
    sendEvent()
  })

  return {
    ...toRefs(state),
    disabledDate,
    buildParams,
    getTransferedTaskQueryConditions,
    setQueryParams,
    sendEvent
  }
}
